import dmsFalcor from "./dms-falcor"
import dmsView from "./dms-view"
import dmsRouter from "./dms-router"

import dmsProvider from "./dms-provider"
import dmsManager from "./dms-manager"
import dmsConsumer from "./dms-consumer"

import { dmsCreate, dmsEdit } from "./dms-create"

import dmsShare from "./dms-share"

const Wrappers = {
  "dms-falcor": dmsFalcor,
  "dms-view": dmsView,
  "dms-router": dmsRouter,
  "dms-provider": dmsProvider,
  "dms-manager": dmsManager,
  "dms-consumer": dmsConsumer,
  "dms-share": dmsShare,
  "dms-create": dmsCreate,
  "dms-edit": dmsEdit
}
export default Wrappers;
